// Map spreadsheet rows to label products; detects columns by header name, else A-G order.
const norm = (v) => String(v ?? '').trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

const COLS = {
  name: [['nombre', 'producto'], 0],
  code: [['codigo', 'code', 'barra'], 1],
  price: [['precio', 'price'], 2],
  description: [['descrip'], 3],
  quantity: [['cantidad', 'qty'], 4],
  size: [['talla', 'size', 'tamano'], 5],
  color: [['color'], 6],
};

export const rowsToLabelProducts = (rows) => {
  const first = (rows[0] || []).map(norm);
  const hasHeader = first.some(h => ['nombre', 'producto', 'codigo', 'precio', 'talla', 'color'].some(k => h.includes(k)));
  const col = {};
  Object.entries(COLS).forEach(([k, [keys, def]]) => {
    col[k] = hasHeader ? first.findIndex(h => keys.some(x => h.includes(x))) : def;
  });
  const get = (row, k) => (col[k] >= 0 ? String(row[col[k]] ?? '').trim() : '');
  const base = Date.now();
  return rows.slice(hasHeader ? 1 : 0)
    .filter(row => row && (get(row, 'name') || get(row, 'code')))
    .map((row, i) => ({
      id: base + i,
      name: get(row, 'name'),
      code: get(row, 'code'),
      price: get(row, 'price'),
      description: get(row, 'description'),
      size: get(row, 'size'),
      color: get(row, 'color'),
      quantity: parseInt(get(row, 'quantity')) || 1,
    }));
};
